/* Item 55: bottom-of-page pack picker. It owns no offer state and no purchase handler.
   Every click delegates to the top controls (.pkg2-row, #pkg2Sub, #pkg2Cta) owned by commerce,
   and the view mirrors the top picker on each acfq:selection-change. */
(function(){'use strict';
 const body=document.body;
 if(!body||!body.classList.contains('acf-pdp-v1'))return;
 const mount=document.querySelector('[data-acfq-bottom-picker]');
 if(!mount||mount.dataset.ready)return;
 const topRows=()=>[...document.querySelectorAll('#pricing .pkg2-row[data-pack]')];
 const main=()=>document.getElementById('pkg2Cta');
 if(!topRows().length||!main())return;
 mount.dataset.ready='true';
 const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text!=null)n.textContent=text;return n;};

 const list=el('div','acfq-bp-list');list.setAttribute('role','radiogroup');list.setAttribute('aria-label','Choose quantity');
 const rows=topRows().map(src=>{const b=el('button','acfq-bp-row');b.type='button';b.setAttribute('role','radio');b.dataset.pack=src.dataset.pack;list.append(b);return b;});
 const basis=el('p','acfq-bp-basis');
 const sub=el('button','acfq-bp-sub');sub.type='button';sub.setAttribute('role','checkbox');
 const chk=el('span','pkg2-sub-chk');chk.setAttribute('aria-hidden','true');
 const subTitle=el('span','acfq-bp-sub-title');
 sub.append(chk,subTitle);
 const subDesc=el('p','acfq-bp-sub-desc');
 const cta=el('button','cta-btn acfq-bp-cta','Add to Cart →');cta.type='button';cta.disabled=true;
 const card=document.getElementById('acfq1102-guarantee')?.cloneNode(true);if(card){card.removeAttribute('id');}
 const trust=el('ul','acfq-trust');
 const ship=el('li','acfq-trust-ship');const shipIcon=document.querySelector('#pricing .acfq-trust-ship svg')?.cloneNode(true);const shipText=el('span','acf-delivery-note acfq-bp-ship');if(shipIcon)ship.append(shipIcon);ship.append(shipText);
 const phone=document.querySelector('#pricing .acfq-trust-phone')?.cloneNode(true);phone?.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));
 trust.append(ship);if(phone)trust.append(phone);
 const deliver=document.querySelector('#pricing [data-acfq-deliver]')?.cloneNode(true);
 /*acfq-r7-E pay: same payment icon row as the main buy box (Shopify enabled list, rendered by Liquid), cloned under this CTA*/
 const pay=document.querySelector('#pricing .acfq-pay')?.cloneNode(true);pay?.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));pay?.querySelectorAll('[aria-labelledby]').forEach(n=>n.removeAttribute('aria-labelledby'));
 mount.append(list,basis,sub,subDesc,cta);if(deliver)mount.append(deliver);if(pay)mount.append(pay);if(card)mount.append(card);mount.append(trust);/*acfq-r7-E pay end*/

 function sync(){
  topRows().forEach((src,i)=>{
   const b=rows[i];if(!b)return;
   if(b.innerHTML!==src.innerHTML)b.innerHTML=src.innerHTML;
   b.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));
   const on=src.classList.contains('selected');
   b.classList.toggle('selected',on);b.setAttribute('aria-checked',String(on));b.tabIndex=on?0:-1;
   b.setAttribute('aria-label',src.textContent.replace(/\s+/g,' ').trim());
  });
  const topBasis=document.querySelector('#pricing .acf-price-basis');basis.textContent=topBasis?topBasis.textContent:'';basis.hidden=!topBasis;
  const input=document.getElementById('pkg2Sub'),on=!!input?.checked;
  sub.setAttribute('aria-checked',String(on));chk.classList.toggle('unchecked',!on);
  subTitle.textContent=document.querySelector('#pricing .pkg2-sub-title')?.textContent||'Subscribe and Save';
  subDesc.textContent=document.getElementById('pkg2SubDesc')?.textContent||'';
  const m=main();cta.disabled=!m||m.disabled;cta.textContent=m?m.textContent:'Add to Cart →';
  shipText.textContent=document.getElementById('acfbp-initial-shipping')?.textContent||'';
 }
 list.addEventListener('click',e=>{const b=e.target.closest('.acfq-bp-row');if(!b)return;document.querySelector(`#pricing .pkg2-row[data-pack="${b.dataset.pack}"]`)?.click();});
 list.addEventListener('keydown',e=>{if(!['ArrowDown','ArrowUp','ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();const i=rows.indexOf(document.activeElement);const n=rows[((i<0?0:i)+(['ArrowDown','ArrowRight'].includes(e.key)?1:-1)+rows.length)%rows.length];n.click();n.focus();});
 sub.addEventListener('click',()=>{document.getElementById('pkg2Sub')?.click();});
 cta.addEventListener('click',()=>{const m=main();if(m&&!m.disabled)m.click();else sync();});
 document.addEventListener('acfq:selection-change',()=>requestAnimationFrame(sync));
 new MutationObserver(sync).observe(main(),{attributes:true,attributeFilter:['disabled'],childList:true,characterData:true,subtree:true});
 window.addEventListener('pageshow',()=>requestAnimationFrame(sync));
 sync();
})();
